module.exports = __webpack_public_path__ + "img/cabbage-small.19d411f8.png";